
// Initialize or get the swiper scripts manager
if (!window.swiperScriptsManager) {
  window.swiperScriptsManager = {
    swiperLoaded: false
  };
}

function gridcarousel(){
  // Check if Swiper is available
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded yet. Retrying in 100ms...');
    setTimeout(gridcarousel, 100);
    return;
  }
  
  var productslider=[];
  document.querySelectorAll('.grid-mb-slider').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.snippet-product-card.product-grid');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject = {
      loop: eval(Element.dataset.loop),
      slidesPerGroup: 1,
      slidesPerView: "auto",
      loop: true,
      navigation: {
        nextEl: nextbutton,
        prevEl: prevbutton,
      }
    };
    productslider[productid]=new Swiper(Element,swiperObject);
  });
  // document.querySelectorAll('.variant-grid').forEach(function(sizeList){
  //   sizeList.addEventListener('click',function(e){
  //     e.preventDefault();
  //     let variant_id = sizeList.dataset.id;
  //     let error_grid_outer = sizeList.closest('.snippet-product-card');
  //     let error_grid = error_grid_outer.querySelector('.grid-error');
  //     let formData = {
  //       'items': [{
  //         'id': variant_id,
  //         'quantity': 1
  //       }]
  //     };
  //     fetch('/cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(formData),
  //     })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if(data.status == 422){
  //         error_grid.innerHTML = data.description;
  //         setTimeout(function(e){
  //           error_grid.innerHTML = '';
  //         },2000);
  //       }else{
  //         if(document.location.href.indexOf('/cart') > -1) {
  //           window.location.href = "/cart";
  //         }else{
  //           if(typeof load_cart == 'function'){
  //             load_cart();
  //             setTimeout(function(e){
  //               document.querySelector('body').classList.add('open-drawer');
  //             },500);
  //           }else{
  //             window.location.href = "/cart";
  //           }          
  //         }
  //         const url = '/cart.js';
  //         fetch(url)
  //         .then((resp) => resp.json())
  //         .then(function(data) {
  //           var cart_count = data.item_count;
  //           if(cart_count>0){
  //             document.querySelector('.cart-count').innerHTML = cart_count;
  //           }else{
  //             document.querySelector('.cart-count').innerHTML = '';
  //           }
  //         })
  //         .catch(function(error) {
  //           console.log(error);
  //         })
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // });
}
// Function to initialize collection features
function initializeCollectionFeatures() {
  gridcarousel();
  window.addEventListener("resize", gridcarousel);
}

// Check if Swiper is already loaded
if (!window.swiperScriptsManager.swiperLoaded && typeof Swiper === 'undefined') {
  const swiperScript = document.createElement('script');
  swiperScript.src = document.querySelector('script[src*="collection-section.js"]').src.replace('collection-section.js', 'slider.js');
  swiperScript.defer = true;
  swiperScript.onload = function() {
    window.swiperScriptsManager.swiperLoaded = true;
    setTimeout(initializeCollectionFeatures, 500);
  };
  swiperScript.onerror = function() {
    console.error('Failed to load Swiper library');
  };
  document.head.appendChild(swiperScript);
} else {
  setTimeout(initializeCollectionFeatures, 500);
}
var advance = function() {
  // Make sure Swiper is available before calling gridcarousel
  if (typeof Swiper !== 'undefined') {
    gridcarousel();
  } else {
    console.warn('Swiper not available in advance function');
  }

  //call badge function again
  setTimeout(function() {
      const elements = document.querySelectorAll('.grid-badge span, .grid-badge-pdp span');

      elements.forEach(function(span) {
          var isoCodes = span.getAttribute('data-isocode');

          if (!isoCodes) {
              // Show span if data-isocode is empty
              span.style.display = 'block';
          } else if (isoCodes.includes(code)) {
              // Hide the span if the current country code is found in data-isocode
              span.style.display = 'none';
          } else {
              // Show the span if the current country code is not found in data-isocode
              span.style.display = 'block';
          }
      });
  }, 3000); // Adjust the timeout duration as needed

  setTimeout(function() {
      const upsellDivs = document.querySelectorAll('.main-upsell');
      let isMatchFound = false;

      if (upsellDivs) {
          upsellDivs.forEach(div => {
              const countryCode = div.getAttribute('data-val');
              if (countryCode) {
                  if (countryCode.includes(code)) {
                      div.style.display = 'flex'; // Show the matching upsell

                      var i = 0,
                          items = div.querySelectorAll(".pro-title"),
                          itemsHeight = [];
                      for (i = 0; i < items.length; i++)
                          itemsHeight.push(items[i].offsetHeight);
                      var maxHeight = Math.max(...itemsHeight);
                      for (i = 0; i < items.length; i++)
                          items[i].style.height = maxHeight + "px";

                      isMatchFound = true;
                  } else {
                      div.style.display = 'none'; // Hide non-matching upsells
                  }
              } else {
                  div.style.display = 'none';
              }
          });
          // If no match found, show the first upsell
          if (!isMatchFound && upsellDivs.length > 0) {
              upsellDivs[0].style.display = 'flex';
          }
      }
  }, 1000);
  document.dispatchEvent(new 
  CustomEvent("swym:collections-loaded"));
}
var infinitescroll = {
  scolljs: function(){
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      callback: advance,
      offset:1000
    });
  }
}
infinitescroll.scolljs();
document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  var scrollTop = sessionStorage?.getItem('scrollPos')
  var buttonTop = document.querySelector('.collection-btm-wrap');
  var buttonScroll = buttonTop.offsetTop - window.scrollY;
  document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
  if(buttonScroll < scrollTop){
    var buttonScroll = buttonTop.offsetTop - window.scrollY ;
    scrollManualy(buttonScroll);
  }else{
     scrollManualy(scrollTop);
  }
  function scrollManualy(scrollTop1){
    scrollTop1 = parseInt(scrollTop1);
    window.scrollTo(0,scrollTop1)
    setTimeout(function(){
      if(buttonScroll < scrollTop){
      buttonScroll = buttonTop.offsetTop ;
        scrollManualy(buttonScroll);
      } else {
        window.scrollTo(0,scrollTop)
        return false;
      }
    },500);
  }
}
if(document.querySelector('.view-button') != null){
  document.querySelector('.view-button').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('body').classList.add("open-view");
  })
}
window.addEventListener("scroll", (event) => {
  let widnowHeight = window.outerHeight;
  if(document.querySelector('.collection-btm-wrap') != null){
    let scrollCount = window.pageYOffset;
    let bottom_diff = document.querySelector('.collection-btm-wrap').clientHeight - document.querySelector('.collection-pagination').clientHeight
    let bottom = document.querySelector('.collection-pagination').offsetTop - document.querySelector('.collection-btm-wrap').offsetTop
    if(scrollCount >= document.querySelector('.collection-btm-wrap').offsetTop){
      if(scrollCount > (document.querySelector('.collection-btm-wrap').offsetTop + 150)){
        document.querySelector('.collection-btm-wrap').classList.add('active');
      }else{
        document.querySelector('.collection-btm-wrap').classList.remove('active');
      }
    }
  }
});

const rememberGrid = () => {
  const gridtype = sessionStorage.getItem("col-view")
  if (gridtype === 'packshot') {
    document.querySelector('#product-grid').classList.add('packshot-grid')

    
    // document.querySelectorAll('.swiper').forEach((slider) => {
    //   if (slider.querySelector('.swiper-slide.packshot-img') != null) {
    //      const packshotIndex = slider.querySelector('.swiper-slide.packshot-img').getAttribute("data-index")
    //     // see this: https://swiperjs.com/swiper-api#method-swiper-slideTo
    //     slider.swiper.slideTo(packshotIndex, 0) 
    //   }
    // });      
  }
}
rememberGrid()

const checkViewButton = () => {
  const gridtype = sessionStorage.getItem("col-view")
  if (gridtype === 'packshot') {
     if(document.querySelector('.view-type-packshot') != null){
    document.querySelector('.view-type-packshot').classList.add('active')
     }
  } else {
    if(document.querySelector('.view-type-model') != null){
     document.querySelector('.view-type-model').classList.add('active')
      }
  }
}
checkViewButton()

document.addEventListener("DOMContentLoaded", function() {
    const productType = document.querySelector('.product-type');
    
    if (productType) {
        const listItems = productType.querySelectorAll('ul > li');
        
        if (listItems.length <= 1) {
            productType.style.display = 'none';
        }
    }
});


// $(document).ready(function(){

// if ($(window).width() < 992) {

//   var id = $('.coll-mb-grid li.active').attr('data-id')
//    if(id == '1'){
//       $('body').addClass('mobile-slider');
//        $('.grid-mb-slider.all-slider').show();
//     }else{
//       $('body').removeClass('mobile-slider');
//       $('.grid-mb-slider-new.product-slider').hide();
//       $('.grid-mb-slider-new.model-slider').hide();
//        $('.grid-mb-slider.all-slider').hide()
//     }
  
  
//   $(document).on('click', '.coll-mb-grid li a', function() {
//     var id = $(this).parent('li').attr('data-id')
//     if(id == '1'){
//       $('body').addClass('mobile-slider');
//       $('.grid-mb-slider.all-slider').show();
//     }else{
//       $('body').removeClass('mobile-slider');
//       $('.grid-mb-slider-new.product-slider').hide();
//       $('.grid-mb-slider-new.model-slider').hide();
//       $('.grid-mb-slider.all-slider').hide()
//     }
//   })

//   if ($('body').hasClass("mobile-slider")) {
//       var mySwiper = new Swiper('.swiper.grid-mb-slider-new', {
//       slidesPerView: "auto",
//       loop: true
//   });
//   $(document).on('click', '.coll-ftr-rgt-inr .pro-grid-filter li', function() {
//     $(this).parents('.snippet-collection-filter').removeClass('hide-view');
//           $(this).addClass('active').siblings().removeClass('active')
//           var idd = $(this).attr('data-id');
//           if (idd == 'view-type-packshot') {
//               $('.grid-mb-slider.all-slider , .grid-mb-slider-new.model-slider').hide();
//               $('.grid-mb-slider-new.product-slider').show();
//           } else {
//               $('.grid-mb-slider.all-slider , .grid-mb-slider-new.product-slider').hide();
//               $('.grid-mb-slider-new.model-slider').show();
//           }
//     });
//   }
  
//  }
//  })


// $(document).ready(function(){
//   if ($(window).width() < 992) {
//     var id = $('.coll-mb-grid li.active').attr('data-id')
//      if(id == '1'){
//         $('.coll-ftr-rgt-inr.coll-view').addClass('active')
//          $('.grid-mb-slider.all-slider').show();
//       }else{
//         $('.coll-ftr-rgt-inr.coll-view').removeClass('active')
//         $('.grid-mb-slider , .grid-mb-slider-new').hide();
//       }
//     $(document).on('click', '.coll-mb-grid li a', function() {
//       var id = $(this).parent('li').attr('data-id')
//       if(id == '1'){
//         $('.coll-ftr-rgt-inr.coll-view').addClass('active')
//         $('.grid-mb-slider.all-slider').show();
//       }else{
//         $('.coll-ftr-rgt-inr.coll-view').removeClass('active')
//         $('.grid-mb-slider , .grid-mb-slider-new').hide();
//       }
//     })
//     var mySwiper = new Swiper('.swiper.grid-mb-slider-new', {
//         slidesPerView: "auto",
//         loop: true
//     });
//     $(document).on('click', '.coll-ftr-rgt-inr.active .pro-grid-filter li', function() {
//       $(this).parents('.snippet-collection-filter').removeClass('hide-view');
//       $(this).addClass('active').siblings().removeClass('active')
//       var idd = $(this).attr('data-id');
//       if (idd == 'view-type-packshot') {
//           $('.grid-mb-slider.all-slider , .grid-mb-slider-new.model-slider').hide();
//           $('.grid-mb-slider-new.product-slider').show();
//       } else {
//           $('.grid-mb-slider.all-slider , .grid-mb-slider-new.product-slider').hide();
//           $('.grid-mb-slider-new.model-slider').show();
//       }
//     });
//   }
// })



// function checkWidth() {
//   var windowsize = window.innerWidth;
//   if (windowsize < 992) {
//    var id = document.querySelector('.coll-mb-grid li.active').getAttribute('data-id');
//     if(id === '1'){
//       document.querySelector('.coll-ftr-rgt-inr.coll-view').classList.add('active');
//       document.querySelector('.grid-mb-slider.all-slider').style.display = 'block';
//     } else {
//       document.querySelector('.coll-ftr-rgt-inr.coll-view').classList.remove('active');
//       document.querySelectorAll('.grid-mb-slider, .grid-mb-slider-new').forEach(function(element) {
//         element.style.display = 'none';
//       });
//     }
//     document.addEventListener('click', function(event) {
//       if (event.target.classList.contains('coll-mb-grid') && event.target.tagName === 'A') {
//         var liElement = event.target.parentNode;
//         var id = liElement.getAttribute('data-id');
//         if (id === '1') {
//           alert('yash')
//           document.querySelectorAll('.coll-ftr-rgt-inr.coll-view').forEach(function(element) {
//             element.classList.add('active');
//           });
//           document.querySelectorAll('.grid-mb-slider.all-slider').forEach(function(element) {
//             element.style.display = 'block';
//           });
//         } else {
//           document.querySelectorAll('.coll-ftr-rgt-inr.coll-view').forEach(function(element) {
//             element.classList.remove('active');
//           });
//           document.querySelectorAll('.grid-mb-slider, .grid-mb-slider-new').forEach(function(element) {
//             element.style.display = 'none';
//           });
//         }
//       }
//     });
//     var mySwiper = new Swiper('.swiper.grid-mb-slider-new', {
//         slidesPerView: "auto",
//         loop: true
//     });
//     document.addEventListener('click', function(event) {
//       if (event.target.classList.contains('pro-grid-filter') && event.target.parentNode.classList.contains('coll-ftr-rgt-inr') && event.target.parentNode.classList.contains('active')) {
//         event.target.parentNode.parentNode.classList.remove('hide-view');
//         event.target.classList.add('active');
//         for (const sibling of event.target.parentNode.children) {
//           if (sibling !== event.target) {
//             sibling.classList.remove('active');
//           }
//         }
//         const idd = event.target.getAttribute('data-id');
//         if (idd === 'view-type-packshot') {
//           document.querySelectorAll('.grid-mb-slider.all-slider, .grid-mb-slider-new.model-slider').forEach(element => element.style.display = 'none');
//           document.querySelectorAll('.grid-mb-slider-new.product-slider').forEach(element => element.style.display = 'block');
//         } else {
//           document.querySelectorAll('.grid-mb-slider.all-slider, .grid-mb-slider-new.product-slider').forEach(element => element.style.display = 'none');
//           document.querySelectorAll('.grid-mb-slider-new.model-slider').forEach(element => element.style.display = 'block');
//         }
//       }
//     });
//   }
// }
// window.addEventListener('resize', checkWidth);
// checkWidth();



